import React from "react";
import LabelWithDetailPrint from "./LabelWithDetailPrint";
import { getFormattedDateDDMMMYYYYDate } from "../../../../../utilities/dateFunctions/formatdate";
import { formatINRCurrency } from "../../../../../utilities/currency/currency";

const MiniStatementListPrint = ({
  ledgerList,
  addRepaymentDetails,
  principleDueWithIntData,
  totalDueAmount,
  penalTotalDue,
  ioiTotalDue,
}) => {
  // console.log({ ledgerList });
  return (
    <>
      <section className="border px-3 py-2 text-[10px] my-3 grid grid-cols-3 bg-slate-100 relative">
        <LabelWithDetailPrint
          label={"Name"}
          value={addRepaymentDetails?.applicantname}
        />
        <LabelWithDetailPrint
          label={"Loan ID"}
          value={addRepaymentDetails?.loanee_id}
        />
        <LabelWithDetailPrint
          label={"Loan No"}
          value={addRepaymentDetails?.loan_number}
        />
        <LabelWithDetailPrint
          label={"Category"}
          value={addRepaymentDetails?.categoryname}
        />
        <LabelWithDetailPrint
          label={"Amount"}
          value={formatINRCurrency(addRepaymentDetails?.loanappliedamt)}
        />

        <LabelWithDetailPrint
          label="Int Rate (Scheme)"
          value={`${+principleDueWithIntData?.int_rate}  (${
            addRepaymentDetails?.loan_scheme || "---"
          }) `}
        />
        <LabelWithDetailPrint
          label="Calculation Start Date"
          value={
            getFormattedDateDDMMMYYYYDate(
              principleDueWithIntData?.last_repaymentdate
            ) || "---"
          }
        />
        <LabelWithDetailPrint
          label="No of Days"
          value={principleDueWithIntData?.calculationfordays}
        />

        <LabelWithDetailPrint
          label="Principle Outstanding"
          value={formatINRCurrency(
            principleDueWithIntData?.principle_outstanding_amount
          )}
        />
        <LabelWithDetailPrint
          label="Principle Due"
          value={formatINRCurrency(principleDueWithIntData?.principle_due)}
        />
        <LabelWithDetailPrint
          label="Interest Due"
          value={formatINRCurrency(
            principleDueWithIntData?.interest_due_amount
          )}
        />

        <LabelWithDetailPrint
          label="Total Due Amount"
          value={formatINRCurrency(totalDueAmount)}
        />

        {addRepaymentDetails?.categoryname === "OBC" && (
          <>
            <LabelWithDetailPrint
              label="Penal Due"
              value={formatINRCurrency(penalTotalDue)}
              noRecord={+penalTotalDue === -1 ? true : false}
              isApprox={true}
            />
            <LabelWithDetailPrint
              label="IOI Due"
              value={formatINRCurrency(ioiTotalDue)}
              noRecord={+ioiTotalDue === -1 ? true : false}
              isApprox={true}
            />
          </>
        )}
      </section>

      <table className="min-w-full divide-y divide-slate-200">
        <thead className="bg-slate-200 text-sm my-3 sticky top-0">
          <tr>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Sl No.
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Date
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Repayment Amount
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Interest Due
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Interest Paid
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left font-medium text-slate-900  tracking-wider leading-5"
            >
              Balance
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-100 text-slate-700 text-xs">
          {/* Disbusement details */}
          <tr>
            <td className="px-3 ps-7 py-2 whitespace-nowrap">1</td>
            <td className="px-3 py-2 whitespace-nowrap">
              {getFormattedDateDDMMMYYYYDate(
                addRepaymentDetails?.loan_first_disbursment_date
              )}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(0) || 0}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(0) || 0}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(0) || 0}
            </td>
            <td className="px-3 py-2 whitespace-nowrap">
              {formatINRCurrency(addRepaymentDetails?.loanappliedamt) || 0}
            </td>
          </tr>
          {ledgerList?.length > 0 ? (
            ledgerList?.map((data, index) => (
              <tr
                key={index}
                className={index % 2 === 1 ? "bg-slate-100" : null}
              >
                <td className="px-3 ps-7 py-2 whitespace-nowrap">
                  {index + 2}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {getFormattedDateDDMMMYYYYDate(data?.tr_date)}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.amount) || 0}
                </td>

                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.interest_due) || 0}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.interest_paid) || 0}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">
                  {formatINRCurrency(data?.balance) || 0}
                </td>
              </tr>
            ))
          ) : (
            <td colSpan={8} className="p-4 text-center">
              {" "}
              No Record Found
            </td>
          )}
        </tbody>
      </table>
    </>
  );
};

export default MiniStatementListPrint;
